import { Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC, PropsWithChildren } from 'react';

export const ErrorAlert: FC<PropsWithChildren> = ({
  children,
}): JSX.Element => {
  const theme = useTheme();
  return (
    <Alert severity='error' icon={false} sx={{

      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.error.main : '',
      color: theme.palette.mode === 'dark' ? '#fff' : '#000'
    }}>
      {children}
    </Alert>
  );
};
